import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';

const VISITED_VALUE = 'true';

/**
 * Set when the user opens the Enterprise demo tab on /signup (experiment).
 * Used to attribute trial signups and tab-back behavior within the session.
 */
export const signupVisitedEnterpriseDemoTabSlot = createStorageSlot('signup-visited-enterprise-demo-tab', {
  storageType: 'sessionStorage',
});

export function markSignupEnterpriseDemoTabVisited(): void {
  signupVisitedEnterpriseDemoTabSlot.set(VISITED_VALUE);
}

export function hasVisitedSignupEnterpriseDemoTab(): boolean {
  return signupVisitedEnterpriseDemoTabSlot.get() === VISITED_VALUE;
}
